import styled from "styled-components";

export const SingleTagContainer = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  width: fit-content;

  display: flex;
  gap: 0.5rem;
  padding: 0.625rem 0;

  p {
    font: 400 0.813/1.219 "Inter";
    color: ${({ theme }) => theme.groups.secondaryText};
    margin: 0;
    text-align: start;
  }
`;
